import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Tag, ChevronRight } from 'lucide-react';
import { useGenreStore } from '../../hooks/useStore';
import './Genres.css';

const Genres = () => {
  const { genres, fetchGenres, isLoading } = useGenreStore();

  useEffect(() => {
    fetchGenres();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <main className="genres-page">
        <div className="container">
          <div className="loading">
            <div className="loading-spinner"></div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="genres-page">
      <div className="container">
        <div className="page-header">
          <Tag size={32} />
          <div>
            <h1>All Genres</h1>
            <p>Browse novels by genre</p>
          </div>
        </div>

        <div className="genres-grid">
          {genres.map((genre) => (
            <Link 
              key={genre._id} 
              to={`/genre/${genre.slug}`}
              className="genre-card"
            >
              <span className="genre-icon">{genre.icon || '📚'}</span>
              <div className="genre-info">
                <h3>{genre.name}</h3>
                <p>{genre.novelCount || 0} novels</p>
              </div>
              <ChevronRight size={20} className="arrow" />
            </Link>
          ))}
        </div>

        {genres.length === 0 && (
          <div className="empty-state">
            <p>No genres available</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default Genres;
